import { create } from 'zustand';

export const useSocketStore = create((set) => ({
  socket: null,
  onlineUsers: null,
  isRecipientOnline: false,
  sessionConflict: {
    showSessionConflict: false,
    sessionConflictData: null,
  },

  // Setters
  setSocket: (socket) => set({ socket }),
  setOnlineUsers: (users) => set({ onlineUsers: users }),
  setIsRecipientOnline: (online) => set({ isRecipientOnline: online }),
  setSessionConflict: (conflictOrFn) => set((state) => ({
    sessionConflict: typeof conflictOrFn === 'function'
      ? conflictOrFn(state.sessionConflict)
      : conflictOrFn,
  })),
}));
